"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Timeline = void 0;

var _react = _interopRequireWildcard(require("react"));

var _range = _interopRequireDefault(require("lodash/range"));

var _styles = require("@material-ui/core/styles");

var _useColors = _interopRequireDefault(require("../../hooks/use-colors"));

var _TimeStamp = _interopRequireDefault(require("../TimeStamp"));

var _useTimeCursorTime = require("../../hooks/use-time-cursor-time");

var _useRootAudioElm3 = _interopRequireDefault(require("../../hooks/use-root-audio-elm"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _formatTime = require("../../utils/format-time");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styles.styled)("div")(function (_ref) {
  var width = _ref.width,
      themeColors = _ref.themeColors;
  return {
    width: width,
    overflow: "hidden",
    position: "relative",
    height: 64,
    cursor: "pointer",
    borderBottom: "1px solid ".concat(themeColors.Selection),
    color: themeColors.fg
  };
});
var TimeText = (0, _styles.styled)("div")(function (_ref2) {
  var x = _ref2.x,
      faded = _ref2.faded;
  return {
    display: "inline-block",
    width: 80,
    fontSize: 12,
    fontVariantNumeric: "tabular-nums",
    position: "absolute",
    top: 16,
    left: x,
    borderLeft: "1px solid rgba(255,255,255,0.5)",
    paddingLeft: 4,
    whiteSpace: "pre-wrap",
    opacity: faded ? 0.25 : 0.75
  };
});
var TimeCursor = (0, _styles.styled)("div")(function (_ref3) {
  var left = _ref3.left,
      themeColors = _ref3.themeColors;
  return {
    position: "absolute",
    width: 0,
    height: 0,
    top: 0,
    left: left - 6,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "12px solid ".concat(themeColors.green)
  };
});
var Svg = (0, _styles.styled)("svg")({
  position: "absolute",
  left: 0,
  bottom: 0
});

var Timeline = function Timeline(_ref4) {
  var timeFormat = _ref4.timeFormat,
      visibleTimeStart = _ref4.visibleTimeStart,
      visibleTimeEnd = _ref4.visibleTimeEnd,
      width = _ref4.width,
      _ref4$timestamps = _ref4.timestamps,
      timestamps = _ref4$timestamps === void 0 ? [] : _ref4$timestamps,
      gridLineMetrics = _ref4.gridLineMetrics,
      onClickTimestamp = _ref4.onClickTimestamp,
      onRemoveTimestamp = _ref4.onRemoveTimestamp,
      timeCursorTimeProp = _ref4.timeCursorTime;
  var themeColors = (0, _useColors.default)();
  var visibleDuration = visibleTimeEnd - visibleTimeStart; // TODO compute tick count using width

  var timeTextCount = Math.ceil(width / 100);
  var timeTextTimes = (0, _range.default)(timeTextCount).map(function (i) {
    return visibleTimeStart + visibleDuration / timeTextCount * i;
  });
  var recoilTimeCursorTime = (0, _useTimeCursorTime.useTimeCursorTime)();
  var setTimeCursorTime = (0, _useTimeCursorTime.useSetTimeCursorTime)();

  var _useRootAudioElm = (0, _useRootAudioElm3.default)(),
      _useRootAudioElm2 = _slicedToArray(_useRootAudioElm, 1),
      rootAudioElm = _useRootAudioElm2[0];

  var timeCursorTime = timeCursorTimeProp === undefined ? recoilTimeCursorTime : timeCursorTimeProp;
  var numberOfMajorGridLines = gridLineMetrics.numberOfMajorGridLines,
      majorGridLinePixelOffset = gridLineMetrics.majorGridLinePixelOffset,
      majorGridLinePixelDistance = gridLineMetrics.majorGridLinePixelDistance;
  var containerRef = (0, _react.useRef)();
  var onClickTimeline = (0, _useEventCallback.default)(function (e) {
    if (!rootAudioElm) return;
    var clientX = e.clientX;
    var pxDistanceFromStart = clientX - containerRef.current.getBoundingClientRect().left;
    var time = pxDistanceFromStart / width * (visibleTimeEnd - visibleTimeStart) + visibleTimeStart;
    rootAudioElm.currentTime = time / 1000;
    setTimeCursorTime(time);
  });
  return /*#__PURE__*/_react.default.createElement(Container, {
    ref: containerRef,
    themeColors: themeColors,
    width: width,
    onClick: rootAudioElm ? onClickTimeline : undefined
  }, (0, _range.default)(timeTextCount).map(function (timeTextIndex) {
    return /*#__PURE__*/_react.default.createElement(TimeText, {
      key: timeTextIndex,
      x: timeTextIndex / timeTextCount * width,
      faded: timeTextTimes[timeTextIndex] < 0
    }, (0, _formatTime.formatTime)(timeTextTimes[timeTextIndex], timeFormat, visibleDuration));
  }), /*#__PURE__*/_react.default.createElement(Svg, {
    width: width,
    height: 12
  }, (0, _range.default)(numberOfMajorGridLines).map(function (tickIndex) {
    var x = majorGridLinePixelOffset + majorGridLinePixelDistance * tickIndex;
    return /*#__PURE__*/_react.default.createElement("line", {
      key: tickIndex,
      x1: x,
      x2: x,
      y1: 0,
      y2: 12,
      stroke: themeColors.base01
    });
  })), timestamps.map(function (timestamp, i) {
    var left = (timestamp.time - visibleTimeStart) / visibleDuration * width;
    return /*#__PURE__*/_react.default.createElement(_TimeStamp.default, _extends({
      key: i,
      left: left
    }, timestamp, {
      onClick: function onClick() {
        return onClickTimestamp(timestamp, i);
      },
      onRemove: function onRemove() {
        return onRemoveTimestamp(timestamp, i);
      }
    }));
  }), timeCursorTime !== undefined && /*#__PURE__*/_react.default.createElement(TimeCursor, {
    themeColors: themeColors,
    left: (timeCursorTime - visibleTimeStart) / visibleDuration * width
  }));
};

exports.Timeline = Timeline;
var _default = Timeline;
exports.default = _default;